import SiteLayout from "@/components/feature/SiteLayout";
import { matches } from "@/mocks/matches";
import { replays } from "@/mocks/replays";
import { analyses } from "@/mocks/analyses";
import { usePageMeta } from "@/hooks/usePageMeta";
import HeroBanner from "@/pages/home/components/HeroBanner";
import LeagueStrip from "@/pages/home/components/LeagueStrip";
import MatchSection from "@/pages/home/components/MatchSection";
import DataBand from "@/pages/home/components/DataBand";
import ReplaySection from "@/pages/home/components/ReplaySection";
import AnalysisSection from "@/pages/home/components/AnalysisSection";

export default function Home() {
  usePageMeta();
  const hotSlides = matches.filter((m) => m.status === "live");

  return (
    <SiteLayout padded={false}>
      <HeroBanner slides={hotSlides} />

      <section className="w-full px-4 md:px-8 py-8 md:py-10 bg-background-50 border-b border-background-200">
        <div className="w-full max-w-[1280px] mx-auto text-center">
          <h1 className="text-2xl md:text-4xl font-semibold text-foreground-950 tracking-tight">
            51网站在线观看免费播播足球
          </h1>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-3xl mx-auto leading-relaxed">
            实时足球赛事直播与精彩回放平台，覆盖英超、西甲、欧冠、世界杯等热门赛事，
            提供高清流畅的观赛体验、赛程赛果查询与深度赛事解析。
          </p>
        </div>
      </section>

      <LeagueStrip />
      <MatchSection matches={matches} />
      <DataBand />
      <ReplaySection replays={replays.slice(0, 4)} />
      <AnalysisSection analyses={analyses.slice(0, 3)} />
    </SiteLayout>
  );
}